
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe08 as ObiHydraulicPipe08Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-08.js';
 
 
 

 
 export const ObiHydraulicPipe08 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-08',
   elementClass: ObiHydraulicPipe08Element,
   events: {
     
   }
  });
 
 